export default state => state.vod.hodor.errors;
